var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-login"},[_c('dialogWindow',{ref:"ConfirmEmailDialog",attrs:{"info":_vm.checkDialogTitle,"size":"max","color":_vm.checkDialogColor},on:{"select-ok":function($event){return _vm.closeDialog()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }